/**
 * Sort array of object (could be nested) by defined property and defined direction
 * @param {object[]} items - array of items to sort
 * @param {string} type - property to sort by - nested objects can be pased as 'prop1.prop2.prop3'
 * @param {boolean} direction - sort direction
 * @returns {object[]} items - array of sorted items
 */
// eslint is disabled because the type of items is unknown - to sustain reusability of the function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sortItems = (items: any[], type: string, direction: boolean): any[] => {
  const nestedType = type.split('.');
    return [...items].sort((a, b) => {
      let aValue = a;
      let bValue = b;
      for (let i = 0; i < nestedType.length; i++) {
        aValue = aValue[nestedType[i]];
        bValue = bValue[nestedType[i]];
      }
      if (aValue < bValue) {
        return direction ? -1 : 1;
      }
      if (aValue > bValue) {
        return direction ? 1 : -1;
      }
      return 0;
    });
};